export async function imageUrlToFile(imageUrl: string, fileName: string) {
  try {
    // Fetch the image from the URL
    const response = await fetch(imageUrl);

    // Check if the fetch was successful
    if (!response.ok) {
      throw new Error(
        `Failed to fetch image: ${response.status} ${response.statusText}`
      );
    }

    // Get the image data as a blob
    const imageBlob = await response.blob();

    // Create a File object from the blob
    const imageFile = new File([imageBlob], fileName, {
      type: imageBlob.type || "image/jpeg"
    });

    return imageFile;
  } catch (error) {
    console.error("Error converting image URL to file:", error);
    throw error;
  }
}
